/* eslint-disable */
import React, { useState, useRef } from "react";
import _Input from "../../../generic/_Input";
import _Button from "../../../generic/_Button";
import Icon from "../../../Icon";
import Overlay from "react-bootstrap/Overlay";
import PropTypes from "prop-types";
import {dateFormat } from '../../../../utils/dateHelpers';
const RangeDate = (props) => {
  const { onChange, dateFrom, dateTo, errors, required } = props;
  const target = useRef(null);
  const [visible, setVisible] = useState(false);

  return (
    <div className="w-full">
      <div className="my-2">
      <label className="text-gray-700 font-semibold text-sm flex justify-start align-top mb-2">
        Rango de Fecha
        {required && <span className="text-red-700 mx-1">*</span>}
      </label>
      <div className="flex flex-row bg-gray-25 p-2 border border-gray-200 rounded gap-2 cursor-pointer" ref={target} onClick={() => setVisible(true)}>
        <Icon
          icon="date_range"
          className="flex items-center justify-center text-[16px] text-secondary"
        />
        <span className="font-medium text-[14.5px] leading-[20px] text-secondary text-nowrap line-clamp-1">
          {dateFormat(dateFrom, "YYYY/MM/DD")} - {dateFormat(dateTo, "YYYY/MM/DD")}
        </span>
      </div>
      </div>

      <Overlay
        target={target.current}
        show={visible}
        placement="bottom"
        rootClose
        onHide={() => setVisible(false)}
        container={document.body}
      >
        {({ placement, arrowProps, show: _show, popper, ...overlayProps }) => (
          <div
            {...overlayProps}
            className="bg-white rounded-lg shadow-lg border border-gray-200 z-[9999] p-4"
            style={{
              ...overlayProps.style,
            }}
          >
            <_Input
              value={dateFrom}
              onChange={(e) => {
                const value = {
                  target: {
                    name: "dateFrom",
                    value: e.target.value,
                  },
                };
                onChange(value);
              }}
              name="dateFrom"
              title="Desde"
              type="date"
              required
              isError={errors?.period?.dateFrom ? true : false}
              errors={errors?.period?.dateFrom ? errors?.period?.dateFrom : ""}
            />
            <_Input
              value={dateTo}
              onChange={(e) => {
                const value = {
                  target: {
                    name: "dateTo",
                    value: e.target.value,
                  },
                };
                onChange(value);
              }}
              name="dateTo"
              title="Hasta"
              type="date"
              required
              isError={errors?.period?.dateTo ? true : false}
              errors={errors?.period?.dateTo ? errors?.period?.dateTo : ""}
            />
          </div>
        )}
      </Overlay>
    </div>
  );
};

RangeDate.propTypes = {
  dateFrom: PropTypes.string,
  dateTo: PropTypes.string,
  onChange: PropTypes.func,
  errors: PropTypes.object,
  required: PropTypes.bool,
};

export default RangeDate;
